<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                        <label>Geographic Area</label>
                                        <select v-model="salesdata.region" required name="region" class="form-control" @change="getSite">
                                            <option disabled selected>Select G.A</option>
                                                <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                    <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">G.A is a required field</div>
                                    </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.site)">
                                        <label>Location</label>
                                        <select v-model="salesdata.site" required name="site" class="form-control" @change="getDispenserCount">
                                            <option disabled> Select Location</option>
                                                <option v-for="(item,index) in site_list" :key="index" v-bind:value="item._id" v-bind:count="item.dispenserCount">
                                                {{item.siteName}}
                                            </option>
                                        </select>
                                    
                                    <field-messages name="site" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Location is a required field</div>
                                    </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportedDate)">
                                        <label>Report Date</label>
                                        <!-- <date-picker  id="reportedDate" required v-model="salesdata.reportedDate" lang="en" name="reportedDate" input-class="form-control" width="100%" format="DD-MM-YYYY"></date-picker> -->
                                        <VueCtkDateTimePicker  id="reportedDate" required v-model="salesdata.reportedDate" lang="en" name="reportedDate" input-class="form-control" width="100%" format="MM-DD-YYYY hh:mm a"></VueCtkDateTimePicker>
                                        <field-messages name="reportedDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Date is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <!-- <div class="col-sm-3">
                                    <label>Location</label>
                                    <select class="form-control" @change="enableLocation">
                                        <option>Select</option>
                                        <option value ="Car">Car</option>
                                        <option value="Bus">Bus</option>
                                    </select>
                                </div> -->
                            </div>
                            <div class="col-sm-12">
                                <legend class="col-md-12">Sales Data</legend>
                            </div>
                            <div id="Car">
                                <div class="col-sm-12" id="dispenser"  v-for="(dispenser_number,i) in this.totalDispenser">
                                    <div class="col-sm-12">
                                        <br>
                                        <label > Dispenser {{dispenser_number}} </label>
                                        <br>
                                    </div>
                                    <div class="col-sm-12">
                                    <div class="col-sm-2">                                                                              
                                        <label>Nozzle A Opening</label>
                                        <input type="number" name="a"  ref="nozzleAOpening" class="form-control" required v-model="dispenserFormData['nozzleAOpening'][i]" @change="fillNext($event,i,'nozzleAOpening')">

                                    </div>
                                    <div class="col-sm-2">
                                        <label>Nozzle A Closing</label>
                                        <input type="number" :min="this.refs" name="b" ref="nozzleAClosing" class="form-control" required v-model="dispenserFormData['nozzleAClosing'][i]" :disabled="disabledInput" @change="compareValue($event,i,'nozzleAClosing')">                                        
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Meter Jump A</label>
                                        <input type="number" ref="nozzleAMeterJump"  class="form-control" required v-model="dispenserFormData['nozzleAMeterJump'][i]" :disabled="disabledInput">                                       
                                    </div>
                                    <div class="col-sm-2">
                                        <label>Nozzle B Opening</label>
                                        <input type="number" ref="nozzleBOpening"  class="form-control" required v-model="dispenserFormData['nozzleBOpening'][i]" @change="fillNext($event,i,'nozzleBOpening')" >                                    
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Nozzle B closing</label>
                                        <input type="number" ref="nozzleBClosing"  class="form-control" required v-model="dispenserFormData['nozzleBClosing'][i]" :disabled="disabledInput" @change="compareValue($event,i,'nozzleBClosing')">                                        
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Meter Jump B</label>
                                        <input type="number" ref="nozzleBMeterJump"  class="form-control" required v-model="dispenserFormData['nozzleBMeterJump'][i]" :disabled="disabledInput">                                       
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div id="Bus"  class="tabcontent">
                                <div class="col-sm-12" id="dispenser"  v-for="dispenser_number in total_dispancer" >
                                    <div class="col-sm-2">                                        
                                        <label>Dispenser A Opening</label>
                                        <input type="number" name="name" class="form-control" required v-model="salesdata.dispenserData.nozzle_A_opening[dispenser_number]">
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Dispenser A Closing</label>
                                        <input type="number" name="name" class="form-control" required v-model="salesdata.dispenserData.nozzle_A_closing[dispenser_number]">
                                        
                                    </div>
                                    <div class="col-sm-2">                                        
                                        <label>Meter Jump A</label>
                                        <input type="number" name="name" class="form-control" required v-model="salesdata.dispenserData.meterJumpA[dispenser_number]">                                       
                                    </div>
                                </div>
                            </div> -->
                            <br><br>
                            <div class="col-sm-12">
                                <div class="col-sm-10"></div>
                                <div class="col-sm-2 text-left">
                                    <br>
                                    
                                    <label> Total Quantity</label>
                                    <input type="number" name="totalValue" class="form-control" v-model="salesdata.totalValue"> 
                                </div> 
                            </div>
                        </vue-form>
                        <div></div><br><br>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'salesdata' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                                <button class="mr-5 btn gradientbt" type="submit" @click="createSaleData" :disabled="!(formstate.$dirty && formstate.$valid)">Add Sales Status</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , salesdataService} from '../../../services'
import { EVENTS } from '../../../config'

export default {
    name:'SalesdataCreate',
    data() {
        return {
            count:'',
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            disabledInput:true,
            formstate: {},
            region_list :{},
            site_list :{},
            minAClosing:0,
            tt: 0,
            i:1,
            salesData:[],
            salesdata :{
                status : 'active',
                dispenserFormData: {
                    nozzleAOpening:[],
                    nozzleAClosing:[],
                    nozzleAMeterJump:[],
                    nozzleBOpening:[],
                    nozzleBClosing:[],
                    nozzleBMeterJump:[],
                },
            },
            dispenserFormData: {
                    nozzleAOpening:[],
                    nozzleAClosing:[],
                    nozzleAMeterJump:[],
                    nozzleBOpening:[],
                    nozzleBClosing:[],
                    nozzleBMeterJump:[],
            },
            //total_dispancer : '',
            totalDispenser : 0,
        }
    },
    mounted () {
        this.getRegion()
    },
    methods :{
        fieldClassName: formService.fieldClassName,
        fillNext(e,i,name){
            if(name == 'nozzleAOpening'){
                this.$refs['nozzleAClosing'][i].disabled = false
                this.$refs['nozzleAMeterJump'][i].disabled = false
            }
            if(name == 'nozzleBOpening'){
                this.$refs['nozzleBClosing'][i].disabled = false
                 this.$refs['nozzleBMeterJump'][i].disabled = false
            }
        },
        compareValue(e,i,name){
            if(name == 'nozzleAClosing' ){
                console.log("hello")
               if(Number(this.$refs['nozzleAOpening'][i].value) > Number(this.$refs['nozzleAClosing'][i].value)){
                   console.log("Please enter value greater than Opening value")
                   this.dispenserFormData['nozzleAClosing'][i] = this.dispenserFormData['nozzleAOpening'][i]
                    this.$snotify.error("Please enter value greater than Opening value")
                    // delete this.dispenserFormData['nozzleAClosing'][i]
               }
            }
            if(name == 'nozzleBClosing' ){
                console.log("hello" , this.$refs['nozzleAClosing'][i].value)
               if(Number(this.$refs['nozzleBOpening'][i].value) > Number(this.$refs['nozzleBClosing'][i].value)){
                   this.dispenserFormData['nozzleBClosing'][i] = this.dispenserFormData['nozzleBOpening'][i]
                   this.$snotify.error("Please enter value greater than Opening value")
                //    delete this.dispenserFormData['nozzleBClosing'][i]
               }
            }
        },
        createSaleData(){
            this.loading = true;
            for(let i=0;i<this.totalDispenser;i++){
                this.salesData.splice(i,1,
                {
                        nozzleA :
                            {
                                nozzleAOpening:this.dispenserFormData.nozzleAOpening[i]? this.dispenserFormData.nozzleAOpening[i]: 0,
                                nozzleAClosing:this.dispenserFormData.nozzleAClosing[i] ? this.dispenserFormData.nozzleAClosing[i]: 0 ,
                                nozzleAMeterJump:this.dispenserFormData.nozzleAMeterJump[i]? this.dispenserFormData.nozzleAMeterJump[i]: 0
                            },
                        nozzleB :
                            {
                                nozzleBOpening:this.dispenserFormData.nozzleBOpening[i] ? this.dispenserFormData.nozzleBOpening[i]: 0,
                                nozzleBClosing:this.dispenserFormData.nozzleBClosing[i] ? this.dispenserFormData.nozzleBClosing[i]: 0,
                                nozzleBMeterJump:this.dispenserFormData.nozzleBMeterJump[i] ? this.dispenserFormData.nozzleBMeterJump[i]: 0
                            }
                    }
                )
            }
            console.log("this.salesData", this.salesData)
            this.salesdata = {
                ...this.salesdata,
                dispenserData : this.salesData,
                // reportedDate : new Date(this.salesData.reportedDate)
            }
            // this.salesdata.reportedDate = new Date(this.salesData.reportedDate)
            return salesdataService.addsalesdata(this.salesdata)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Sales Data added!', 'Success!')
                this.$router.push('/sales_settings')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Sales Data Add failed!Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'New Sales Data add is failed.Please try again!'
                }
            })  
        },    
        getRegion() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                       
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getSite(e){
            const params  = {}
            params.$limit = 0;
            params.region = e.target.value;
            params.siteType = "DBS"
            let sitelist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        sitelist =  res.data.docs;
                       
                    }
                    this.site_list = sitelist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })
        },
        getDispenserCount(e){
            this.count =  e.target.options[e.target.selectedIndex].getAttribute('count');
            // console.log("hhdhfj",this.count)
            
            // this.total_dispancer = parseInt(this.count)
            // console.log ("total_dispenser",this.total_dispancer)
            this.totalDispenser = parseInt(this.count)
            // console.log("totalDispenser",this.totalDispenser)
            
        },          
    }
}
</script>
<style scoped>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .gradientbt{
        background: #3085d6;
        color: white
    }
</style>



// WEBPACK FOOTER //
// SalesdataCreate.vue?08afd338